var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g2, _g3, _rect7, _rect8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 336,
    viewBox: "0 0 383 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 209.961,
    cy: 168,
    r: 167.765,
    fill: "#333F66"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_198_10020)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.5474,
    y: 66.3733,
    width: 327.464,
    height: 224.224,
    rx: 20,
    fill: "#232A43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.0474,
    y: 65.8733,
    width: 328.464,
    height: 225.224,
    rx: 20.5,
    stroke: "#445488"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.58,
    x: 32.5181,
    y: 124.446,
    width: 88.7218,
    height: 8.06562,
    rx: 4.03281,
    fill: "#E7ECFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5181,
    y: 103.475,
    width: 54.8462,
    height: 8.06562,
    rx: 4.03281,
    fill: "#5FC6E3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5181,
    y: 243.978,
    width: 54.8462,
    height: 8.06562,
    rx: 4.03281,
    fill: "#5FC6E3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.58,
    x: 32.5181,
    y: 142.19,
    width: 88.7218,
    height: 8.06562,
    rx: 4.03281,
    fill: "#E7ECFE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.58,
    x: 32.5181,
    y: 159.935,
    width: 88.7218,
    height: 8.06562,
    rx: 4.03281,
    fill: "#E7ECFE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.58,
    x: 32.5181,
    y: 261.722,
    width: 88.7218,
    height: 8.06562,
    rx: 4.03281,
    fill: "#E7ECFE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.144 66.3733V288.945",
    stroke: "#EEF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.941 66.3733V288.945",
    stroke: "#EEF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.738 66.3733V288.945",
    stroke: "#EEF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.535 66.3733V288.945",
    stroke: "#EEF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.013 122.833L148.665 122.833",
    stroke: "#EEF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.013 179.292L148.665 179.292",
    stroke: "#EEF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.013 235.751L148.665 235.751",
    stroke: "#EEF0F6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_10020)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.022 224.671C338.841 224.671 383.28 180.335 383.28 125.645C383.28 70.9536 338.841 26.6179 284.022 26.6179C229.204 26.6179 184.765 70.9536 184.765 125.645C184.765 180.335 229.204 224.671 284.022 224.671ZM284.022 188.774C318.969 188.774 347.299 160.51 347.299 125.645C347.299 90.7794 318.969 62.5153 284.022 62.5153C249.075 62.5153 220.745 90.7794 220.745 125.645C220.745 160.51 249.075 188.774 284.022 188.774Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.022 224.656C338.841 224.656 383.28 180.32 383.28 125.629C383.28 70.9385 338.841 26.6028 284.022 26.6028C229.204 26.6028 184.765 70.9385 184.765 125.629C184.765 180.32 229.204 224.656 284.022 224.656ZM284.022 188.773C318.969 188.773 347.299 160.509 347.299 125.644C347.299 90.7785 318.969 62.5145 284.022 62.5145C249.075 62.5145 220.745 90.7785 220.745 125.644C220.745 160.509 249.075 188.773 284.022 188.773Z",
    fill: "#929EC7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.171 146.186L190.101 157.88C200.016 185.929 222.524 208.896 250.58 218.91L262.703 185.101C244.664 178.662 230.41 164.284 224.171 146.186Z",
    fill: "#BCC3DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.253 99.8468L193.403 85.178C187.852 97.5323 184.765 111.228 184.765 125.644C184.765 136.929 186.657 147.774 190.142 157.879L224.174 146.194C221.952 139.752 220.745 132.838 220.745 125.644C220.745 116.454 222.714 107.723 226.253 99.8468Z",
    fill: "#EEF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.252 99.8476C236.14 77.8432 258.287 62.5153 284.022 62.5153L284.022 26.6179C243.653 26.6179 208.912 50.6618 193.403 85.1787L226.252 99.8476Z",
    fill: "url(#paint0_linear_198_10020)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.022 26.6179C338.841 26.6179 383.28 70.9536 383.28 125.645C383.28 164.375 360.994 197.912 328.518 214.188L312.388 182.091C333.092 171.715 347.299 150.335 347.299 125.645C347.299 90.7794 318.969 62.5154 284.022 62.5153V26.6179Z",
    fill: "url(#paint1_linear_198_10020)"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 260,
    width: 193,
    height: 10,
    rx: 5,
    fill: "#DDE1EE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 260,
    width: 144.75,
    height: 10,
    rx: 5,
    fill: "url(#paint2_linear_198_10020)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_198_10020",
    x: 0.547363,
    y: 59.3733,
    width: 349.464,
    height: 246.224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_198_10020"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.101961 0 0 0 0 0.380392 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_198_10020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_198_10020",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_198_10020",
    x1: 218.476,
    y1: 94.8299,
    x2: 248.95,
    y2: 21.8325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C5AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_198_10020",
    x1: 383.28,
    y1: 26.6179,
    x2: 221.807,
    y2: 118.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#821BFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C59FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_198_10020",
    x1: 314.75,
    y1: 260,
    x2: 313.464,
    y2: 279.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#821BFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C59FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_10020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 199,
    fill: "white",
    transform: "translate(185 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBanner);
export default __webpack_public_path__ + "static/media/LoginBanner.57f76268c951c14183641971a70b841f.svg";
export { ForwardRef as ReactComponent };